import { Caption } from '@/components';
import React from 'react';
import { companyLogoList } from '../../constants';
import * as styles from './index.module.less';
// import { ReactComponent as LineLeftDeco } from '@/images/svg/line-left-deco.svg';
// import { ReactComponent as LineRightDeco } from '@/images/svg/line-right-deco.svg';
import { IImageProp, LoadingImageUrl } from '@/constants';
import Statistics from '../statistics';

interface IProps {
  honorLogos?: IImageProp[];
  tips?: string;
  isShowTitle?: boolean;
  isShowStatistics?: boolean;
  honorImgClass?: string;
}

const HonorPart = ({
  // honorLogos = HonorList,
  // tips = '※1. 2023年3月7日時点のデータです ※2. 当社調べ。静かな環境で声をクリアに集音された認識結果',
  // isShowTitle = true,
  isShowStatistics = false,
}: // honorImgClass = '',
IProps) => {
  return (
    <div className={styles.honor_container}>
      {/* <div className={styles.honor_part}>
        {isShowTitle && (
          <div className={styles.honor_title_container}>
            <LineLeftDeco stroke="#7B838C" height="24px" />
            <H5 className={styles.honor_title}>
              企業
              <wbr />や<wbr />
              分野
              <wbr />を<wbr />
              問わず延べ
              <wbr />
              200万人
              <wbr />
              以上
              <wbr />の<wbr />方<wbr />に<wbr />
              ご利用
              <wbr />
              いただいて
              <wbr />
              おります
            </H5>
            <LineRightDeco stroke="#7B838C" height="24px" />
          </div>
        )}
        <div className={styles.honor_items}>
          {honorLogos.map((item, index) => {
            return (
              <div key={index}>
                <img src={item.src} alt={item.alt} className={`${honorImgClass} ${styles.honor_item_img}`} />
              </div>
            );
          })}
        </div>
        {tips !== '' && (
          <div className={styles.honor_description}>
            <Caption className={styles.honor_description_caption}>{tips}</Caption>
          </div>
        )}
      </div> */}
      <div className={styles.company_logos}>
        <div className={styles.logo_container_wrapper}>
          <div className={styles.logo_container}>
            {companyLogoList.map((item, index) => {
              return (
                <div key={index} className={styles.company_logo_item}>
                  <img src={LoadingImageUrl} data-src={item.src} alt={item.alt} className="lozad" />
                </div>
              );
            })}
          </div>
          <div className={styles.logo_container}>
            {companyLogoList.map((item, index) => {
              return (
                <div key={index} className={styles.company_logo_item}>
                  <img src={LoadingImageUrl} data-src={item.src} alt={item.alt} className="lozad" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {isShowStatistics && (
        <div className={styles.statistics_part}>
          <Statistics isRotateLine isHeroBanner />
          <div className={styles.honor_description}>
            <Caption className={styles.honor_description_caption}>
              ※1. 日本マーケティングリサーチ機構調べ 調査概要：2023年6月期 ブランドのイメージ調査&nbsp;&nbsp;※2.
              2023年7月10日時点のデータです&nbsp;&nbsp;※3. 当社調べ。静かな環境で声をクリアに集音された認識結果
            </Caption>
          </div>
        </div>
      )}
    </div>
  );
};
export default HonorPart;
